/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import ArticleEditInfoApi from '../../api/ArticleEditInfo';
import * as ActionTypes from '../ActionTypes';
function articleEditInfoRequesting() {
  return {
    type: ActionTypes.FETCH_ARTICLE_EDIT_INFO_PENDING
  };
}
function articleEditInfoReceived(payload) {
  return {
    type: ActionTypes.FETCH_ARTICLE_EDIT_INFO_SUCCESS,
    payload
  };
}
function articleEditInfoRequestFailed(error) {
  return {
    error,
    type: ActionTypes.FETCH_ARTICLE_EDIT_INFO_ERROR
  };
}
export function getArticleEditInfo(articleId) {
  return dispatch => {
    dispatch(articleEditInfoRequesting());
    ArticleEditInfoApi.get(articleId).then(response => dispatch(articleEditInfoReceived(response)), error => dispatch(articleEditInfoRequestFailed(error)));
  };
}
export function clearArticleEditInfoState() {
  return dispatch => {
    dispatch({
      type: ActionTypes.CLEAR_ARTICLE_EDIT_INFO
    });
  };
}